import { Controller } from "@hotwired/stimulus";

// Auto-saves notification preference toggles (global channel,
// category x channel, individual notification x channel) and keeps
// dependent switches visually dimmed when their parent is off.
export default class extends Controller {
  static values = { url: String };

  stop(event) {
    // Keep clicks on summary-embedded toggles from folding the accordion
    event.preventDefault();
    event.stopPropagation();
  }

  async toggle(event) {
    const input = event.target;
    const { kind, key, channel } = input.dataset;
    const enabled = input.checked;

    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-CSRF-Token": this.csrfToken(),
        },
        body: JSON.stringify({
          notification_preference: this.buildPayload(kind, key, channel, enabled),
        }),
      });
      if (!response.ok) throw new Error("save failed");

      this.refreshDimming(kind, key, channel, enabled);
    } catch {
      input.checked = !enabled;
    }
  }

  buildPayload(kind, key, channel, enabled) {
    if (kind === "global") return { [`${channel}_notifications`]: enabled };
    if (kind === "category") return { categories: { [key]: { [channel]: enabled } } };
    return { items: { [key]: { [channel]: enabled } } };
  }

  refreshDimming(kind, key, channel, enabled) {
    if (kind === "item") return;

    const selector =
      kind === "global"
        ? `input[data-channel="${channel}"]:not([data-kind="global"])`
        : `input[data-kind="item"][data-category="${key}"][data-channel="${channel}"]`;

    this.element.querySelectorAll(selector).forEach((toggle) => {
      toggle.closest("label")?.classList.toggle("opacity-40", !this.parentOn(toggle));
    });
  }

  // A toggle is dimmed unless every ancestor level is enabled.
  parentOn(toggle) {
    const { kind, channel, category } = toggle.dataset;
    const globalOn = this.element.querySelector(
      `input[data-kind="global"][data-channel="${channel}"]`
    )?.checked;
    if (kind === "category") return Boolean(globalOn);

    const categoryOn = this.element.querySelector(
      `input[data-kind="category"][data-key="${category}"][data-channel="${channel}"]`
    )?.checked;
    return Boolean(globalOn && categoryOn);
  }

  csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content;
  }
}
